import { EstateResultItem_TheWorkNumberTaxTranscriptInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  transcript: EstateResultItem_TheWorkNumberTaxTranscriptInput;
  assignButton?: React.ReactNode;
  title: string;
  subtitle: string;
};

export default function TranscriptAsset({
  id,
  showAssetBtn,
  transcript,
  assignButton,
  title,
  subtitle,
}: Props) {
  return (
    <Asset
      key={id}
      showAssetBtn={showAssetBtn}
      assignButton={assignButton}
      itemData={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [...JSON.parse(transcript.sectionData!)].map((section: any, i: number) => {
          return { field: section.description, value: section.value, key: i };
        })
      }
      title={title}
      subtitle={subtitle}
    />
  );
}
